import { render, staticRenderFns } from "./finanrec.vue?vue&type=template&id=4753ae8d&scoped=true&"
import script from "./finanrec.vue?vue&type=script&lang=js&"
export * from "./finanrec.vue?vue&type=script&lang=js&"
import style0 from "./finanrec.vue?vue&type=style&index=0&id=4753ae8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4753ae8d",
  null
  
)

export default component.exports